

export const DEIDENTIFY_REQUEST = 'DEIDENTIFY_REQUEST';
export const DEIDENTIFY_SUCCESS = 'DEIDENTIFY_SUCCESS';
export const DEIDENTIFY_ERROR = 'DEIDENTIFY_ERROR';
export const DEIDENTIFY_RESET = 'DEIDENTIFY_RESET';

const initialState = {
    apiState: '',
    loading: false,
    data: null,
    error: null,
    message: '',
};

const deIdentifyReducer = (state = initialState, action) => {
    switch (action.type) {
        case DEIDENTIFY_REQUEST:
            return {
                ...state,
                apiState: 'loading',
                loading: true,
                error: null,
            };
        case DEIDENTIFY_SUCCESS:
            return {
                ...state,
                apiState: 'success',
                loading: false,
                data: action.payload,
                error: null,
            };
        case DEIDENTIFY_ERROR:
            return {
                ...state,
                apiState: 'error',
                loading: false,
                error: action.payload,
                message: action.payload,
            };
        case DEIDENTIFY_RESET:
            return initialState;
        default:
            return state;
    }
};

export default deIdentifyReducer; 